import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import baseStyles from '../Base/Base.styles';
import baseFieldStyles from '../BaseField/BaseField.styles';
import baseButtonStyles from '../BaseButton/BaseButton.styles';
import responsiveAlignment from '../Base/responsiveAlignment';
import {parseResponsiveProperty} from '@converdy/styles';

const flatFields = function (steps) {
  return steps.length === 0
    ? []
    : steps
        .map((step) =>
          step.fields.map((field) => ({...cloneDeep(field), step})),
        )
        .flat(1)
        .map((field) => ({
          id: field.id,
          width: field.width,
          step: field.step,
        }));
};

export default ({button, base, baseFields, steps, gutter}) => {
  const fields = flatFields(steps);
  const jss = {
    root: {
      ...baseStyles(base),
    },
  };

  fields.forEach(({id, width, step = {}}) => {
    if (step.style !== 'horizontal' && step.style !== 'horizontal-condensed') {
      merge(jss.root, {
        [`& #` + id]: parseResponsiveProperty((c) => {
          return c ? {maxWidth: `${(c / 12) * 100}%`} : {};
        }, width),
      });
    }
  });

  merge(jss.root, {
    '& form': {
      width: '100%',
    },
  });

  merge(jss.root, {'& .baseFields': baseFieldStyles(baseFields)});

  merge(jss.root, {'& .baseButton': baseButtonStyles(button)});

  merge(jss.root, {
    '& .step-button': {
      ...parseResponsiveProperty((c) => {
        return c
          ? {
              paddingLeft: `${c / 2}px`,
              paddingRight: `${c / 2}px`,
              marginBottom: `${c / 2}px`,
            }
          : {};
      }, baseFields.gutter),
    },
  });

  merge(jss.root, {'& .step-button': responsiveAlignment(base.alignment)});

  return jss;
};
